import { v4 as uuidv4 } from "uuid";
import GoglobalStoreage from "goglobalstoragenpm";
import moment from "moment";

export const uploadPdf = async (file) => {
  let goglobalStoreage = new GoglobalStoreage();
  await goglobalStoreage.createClient(
    "684fccd2872e8a3dd3330ef4",
    "1A1TVysKmA7xFNFpelNs5uqIwSXXLP4zjODwWMqKGhp",
  );

  if (!file) return;

  const newDate = moment(new Date()).format("MMdYYYY");
  let newName = `${uuidv4()}${newDate}${file.name.split(" ").pop()}`;
  var newFile = new File([file], `${newName}.pdf`, {
    type: "file/pdf",
  });

  goglobalStoreage.upload("sr_music_academy", "sr_music_images", newFile, "");

  return `${process.env.REACT_APP_IMAGE_SERVER}fileName:${newName}.pdf${process.env.REACT_APP_IMAGE_URL}`;
};
